/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getInstitutions } from 'app/entities/institution/institution.reducer';
import { InstitutionType } from 'app/shared/model/enumerations/institution-type.model';
import { createEntity, getEntity, reset, updateEntity } from './institution.reducer';

export const InstitutionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const institutions = useAppSelector(state => state.institution.entities);
  const institutionEntity = useAppSelector(state => state.institution.entity);
  const loading = useAppSelector(state => state.institution.loading);
  const updating = useAppSelector(state => state.institution.updating);
  const updateSuccess = useAppSelector(state => state.institution.updateSuccess);
  const institutionTypeValues = Object.keys(InstitutionType);

  const handleClose = () => {
    navigate(`/institution${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getInstitutions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.microSec = convertDateTimeToServer(values.microSec);
    values.timestampEntry = convertDateTimeToServer(values.timestampEntry);
    values.lastUpdated = convertDateTimeToServer(values.lastUpdated);
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...institutionEntity,
      ...values,
      institution: institutions.find(it => it.id.toString() === values.institution?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          microSec: displayDefaultDateTime(),
          timestampEntry: displayDefaultDateTime(),
          lastUpdated: displayDefaultDateTime(),
        }
      : {
          institutionType: 'INSURANCE_AGENCY',
          ...institutionEntity,
          microSec: convertDateTimeFromServer(institutionEntity.microSec),
          timestampEntry: convertDateTimeFromServer(institutionEntity.timestampEntry),
          lastUpdated: convertDateTimeFromServer(institutionEntity.lastUpdated),
          institution: institutionEntity?.institution?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.institution.home.createOrEditLabel" data-cy="InstitutionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.institution.home.createOrEditLabel">Create or edit a Institution</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="institution-id"
                  label={translate('tinyMedicRestApp.institution.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.institutionCode')}
                id="institution-institutionCode"
                name="institutionCode"
                data-cy="institutionCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.name')}
                id="institution-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.code')}
                id="institution-code"
                name="code"
                data-cy="code"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.address')}
                id="institution-address"
                name="address"
                data-cy="address"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.fax')}
                id="institution-fax"
                name="fax"
                data-cy="fax"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.email')}
                id="institution-email"
                name="email"
                data-cy="email"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.contactEmail')}
                id="institution-contactEmail"
                name="contactEmail"
                data-cy="contactEmail"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.phone')}
                id="institution-phone"
                name="phone"
                data-cy="phone"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.mobile')}
                id="institution-mobile"
                name="mobile"
                data-cy="mobile"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.web')}
                id="institution-web"
                name="web"
                data-cy="web"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.chequePrintingName')}
                id="institution-chequePrintingName"
                name="chequePrintingName"
                data-cy="chequePrintingName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.institutionType')}
                id="institution-institutionType"
                name="institutionType"
                data-cy="institutionType"
                type="select"
              >
                {institutionTypeValues.map(institutionType => (
                  <option value={institutionType} key={institutionType}>
                    {translate(`tinyMedicRestApp.InstitutionType.${institutionType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.pointOfIssueNo')}
                id="institution-pointOfIssueNo"
                name="pointOfIssueNo"
                data-cy="pointOfIssueNo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.descreption')}
                id="institution-descreption"
                name="descreption"
                data-cy="descreption"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.inactive')}
                id="institution-inactive"
                name="inactive"
                data-cy="inactive"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.active')}
                id="institution-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.microSec')}
                id="institution-microSec"
                name="microSec"
                data-cy="microSec"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.timestampEntry')}
                id="institution-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.lastUpdated')}
                id="institution-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.institution.cursor')}
                id="institution-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="institution-institution"
                name="institution"
                data-cy="institution"
                label={translate('tinyMedicRestApp.institution.institution')}
                type="select"
              >
                <option value="" key="0" />
                {institutions
                  ? institutions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/institution" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default InstitutionUpdate;
